import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Modal from '../layouts/Modal';
import ImageInput from '../forms/ImageInput';
import Button from '../misc/Button';
import { RootState } from '../../types/redux';
import { profileService } from '../../services';

interface ProfilePictureModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
}

export default function ProfilePictureModal({ open, setOpen }: ProfilePictureModalProps): JSX.Element {
  const { profilePicture: oldProfilePicture } = useSelector((s: RootState) => s.application);
  const { t } = useTranslation();
  const [image, setImage] = useState<string | undefined>(oldProfilePicture);
  const [imageAction, setImageAction] = useState<'UPLOAD' | 'DELETE' | undefined>();

  useEffect(() => {
    setImage(oldProfilePicture);
    setImageAction(undefined);
  }, [open, oldProfilePicture]);

  const handleSave = async () => {
    if (imageAction === 'UPLOAD' && image) {
      await profileService.setProfilePicture(await fetch(image).then((res) => res.blob() as Promise<File>));
    }
    if (imageAction === 'DELETE') {
      await profileService.deleteProfilePicture();
    }
    setImageAction(undefined);
    setOpen(false);
  };

  return (
    <Modal
      open={open}
      setOpen={setOpen}
      title={t('page.profile.editPicture')}
      className="flex w-full flex-col items-center justify-center">
      <div className="flex flex-col items-center gap-4">
        <ImageInput
          image={image}
          setImage={setImage}
          setImageAction={(a) => setImageAction(a)}
          className="h-96 w-96"
          iconClassName="mx-auto my-auto text-primary text-3xl"
        />
        <div className="ml-auto flex gap-2">
          <Button className="underline" onClick={() => setOpen(false)}>
            {t('general.cancel')}
          </Button>
          <Button variant="primary" onClick={handleSave}>
            {t('general.save')}
          </Button>
        </div>
      </div>
    </Modal>
  );
}
